import {SearchResult} from './searchResult';
import {UserResult} from '../user/user';

import type {
  FieldTypeResponseDto,
  SearchFilterRequestDto,
  UserGroupResponseDto,
} from '../dto';

export const SEARCH_VALUES_SESSION_STORAGE_KEY = 'session-search-values';

export interface SearchContextValue extends SearchValues {
  result: SearchResult;
  searching: boolean;
  refreshing: boolean;
  firstSearch: boolean;
  hasMore: boolean;
  changeValues: (values: SearchValues) => void;
  resetSearch: () => void;
  abortSearch: () => void;
  reload: () => void;
  refreshVisibleAssets: (
    visibleStartIndex: number,
    visibleEndIndex: number,
  ) => void;
  registerVisibleRange: (callback: () => {start: number; end: number}) => void;
  firstPage: boolean;
  waitUntilComplete: () => Promise<void>;
  loadSessionSearchValues: () => SearchValues | undefined;
}

export interface EnumContextValue {
  fieldTypes: Map<string, FieldTypeResponseDto>;
}

export interface UserContextValue extends SearchValues {
  result: UserResult;
  searching: boolean;
  changeValues: (values: SearchValues) => void;
  resetUserSearch: () => void;
  setResult: (user: UserResult) => void;
}

export interface SearchValues {
  userGroups?: UserGroupResponseDto[];
  structureId?: string;
  text?: string;
  filters?: SearchFilterRequestDto;
  page?: number;
  nextPage?: boolean;
  pageSize?: number;
  sort?: string;
  startSearch?: boolean;
}

export enum Fields {
  marke = 'IMI_ITEM22',
  status = 'IMI_ITEM1',
  gtin = 'IMI_ITEM3',
  version = 'PIMG_VERS_NR',
  maxVersion = 'PIMG_MAX_VERS_NR',
  name = 'IMI_ITEM14',
  dateiName = 'PKOM_MNAME',
  dateiGroesse = 'PKOM_PSIZE',
  aktVersion = 'IMI_ITEM25',
  edm = 'IMI_ITEM15',
}

export interface CustomSBSearchProps {
  heroVariant?: boolean;
}
